'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarCircleExclamation, iconCalendarCircleExclamationTag } from '@ni/nimble-components/dist/esm/icons/calendar-circle-exclamation';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarCircleExclamation };
export { iconCalendarCircleExclamationTag };
export const NimbleIconCalendarCircleExclamation = wrap(IconCalendarCircleExclamation);